import React, { useCallback, useEffect } from 'react';
import { Box, ClickAwayListener } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';

import { TrainerToolsIcon } from '@icons';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import SwipeableDrawer from '@core/dashboard/components/SwipeableDrawer';
import { useTrainerTools } from '@features/TrainerTools';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { FAMILIARISE_STATE } from '@core/dashboard/components/HomeBottomBar/constants';
import { AnalyticsType } from '@interfaces/analytics';
import { useOverlay } from '@providers/OverlayProvider';
import OVERLAYS from '@constants/overlays';
import useFamiliarizationTrainerTool from '@features/TrainerTools/hooks/useFamiliarization';
import Content from './Content';
import StopSharingModal from './StopSharingModal';

const TrainerToolsView = () => {
  const { t: translate } = useTranslation();

  const { trackEventAnalytics, familiarizeState } = useMytaverseEvent();

  const { open, setOpen, toggleOpen } = useTrainerTools();

  const { handleClose, handleToggle } = useOverlay(
    OVERLAYS.TRAINER_TOOLS,
    open,
    setOpen,
  );

  useFamiliarizationTrainerTool();

  const handleOpenModal = useCallback(() => {
    handleToggle();
    setOpen(true);
  }, [setOpen]);

  useEffect(() => {
    if (open) {
      trackEventAnalytics(AnalyticsType.NavbarButtonClick, {
        name: 'trainer-tools',
      });
    }
  }, [open, trackEventAnalytics]);

  return (
    <>
      <ClickAwayListener
        onClickAway={() => {
          if (familiarizeState?.name) {
            return;
          }
          handleClose();
        }}
      >
        <Box>
          <HomeBarButton
            label={translate('trainerToolModal.title')}
            icon={<TrainerToolsIcon />}
            isActive={
              open || familiarizeState?.name === FAMILIARISE_STATE.TRAINER_TOOLS
            }
            handleClick={() => {
              handleToggle();
              toggleOpen();
            }}
          />

          <SwipeableDrawer
            position={{
              vertical: isMobileOnly ? 'top' : 'bottom',
              horizontal: 'left',
            }}
            open={open}
            onClose={handleClose}
            onOpen={handleOpenModal}
          >
            <Content onClose={handleClose} />
          </SwipeableDrawer>
        </Box>
      </ClickAwayListener>
      <StopSharingModal />
    </>
  );
};

export default TrainerToolsView;
